import script from "./PaywallAsk.vue?vue&type=script&setup=true&lang=js"
export * from "./PaywallAsk.vue?vue&type=script&setup=true&lang=js"

import "./PaywallAsk.vue?vue&type=style&index=0&id=a52a48b8&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a52a48b8"]])

export default __exports__